import React from 'react';
import { A, ComingSoon, Flex } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { useAppConfig } from '../appConfig';

import reportsSvg from './Images/reports.svg';

const { FormattedMessage } = Intl;

const Reports = () => {
  const appConfig = useAppConfig();
  const redirectToErecruit = () =>
    window.open(`${appConfig?.REACT_APP_ERECRUIT_URL}?op1=CustomReports`);

  return (
    <ComingSoon
      image={reportsSvg}
      title={<FormattedMessage id={messageIds.vms.reports.title} />}
      description={
        <Flex justify="flex-end">
          <FormattedMessage id={messageIds.vms.reports.description} />
          &nbsp;
          <A textDecoration="underline" onClick={redirectToErecruit}>
            <FormattedMessage id={messageIds.vms.reports.legacyPortal} />
          </A>
        </Flex>
      }
    />
  );
};

export default Reports;
